import { cacheRevalidateDuration } from "@/app/models/cache";
import { getCms } from "@/lib/cms";
import Image from "next/image";
import Link from "next/link";

export interface ChatUsProps {
  // link: string;
}

export default async function ChatUs(props: ChatUsProps) {
  const [chatUsContent] = await getCms("chat-uses", "en", {
    next: { revalidate: cacheRevalidateDuration() },
  });

  const chatUs = chatUsContent?.[0];

  return (
    <Link target="_blank" href={chatUs?.link ?? "/"}>
      <div className="bg-linen rounded-[5rem] py-2.5 px-6 flex items-center fixed z-20 gap-1 right-10 bottom-6 cursor-pointer">
        <img
          loading="lazy"
          src="/whatsapp-choco.png"
          className="object-cover block h-5 w-5"
          alt="whatsapp"
          width={20}
          height={20}
        />
        <div className="text-brown font-pluto h-5">
          <p>CHAT US</p>
        </div>
      </div>

    </Link>
  );
}
